/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiCredentialsRequestResponseFromJSON(json) {
    return ApiCredentialsRequestResponseFromJSONTyped(json, false);
}
export function ApiCredentialsRequestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'apiSecret': !exists(json, 'apiSecret') ? undefined : json['apiSecret'],
    };
}
export function ApiCredentialsRequestResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiKey': value.apiKey,
        'apiSecret': value.apiSecret,
    };
}
